import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CompactTaskIcon = React.forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    width="18px"
    height="18px"
    version="1.1"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <>
      <rect width="18" height="18" fill="none" />
      <path d="m9 0a3 3 0 0 0-2.9004 2.25h-3.8496v13.5h13.5v-13.5h-3.8457a3 3 0 0 0-2.9043-2.25zm0 2a1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1zm-3.75 3.25h7.5v1.5h-7.5zm0 3h7.5v1.5h-7.5zm0 3h5.25v1.5h-5.25z" />
    </>
  </SvgIcon>
));

export default CompactTaskIcon;
